<section class="billing-hero" [attr.data-state]="state">
  <div class="billing-hero-copy">
    <h3 class="billing-hero-title">{{ title }}</h3>
    <p class="billing-hero-price" *ngIf="priceLine && (state === 'active' || state === 'renew_window' || state === 'addon_locked')">{{ priceLine }}</p>
    <p class="billing-hero-body">{{ body }}</p>
    <p class="billing-hero-notice" *ngIf="statusNotice" role="status">{{ statusNotice }}</p>
    <div class="billing-hero-meter" *ngIf="showMeter">
      <div class="billing-hero-meter-label">
        <span>Seats</span>
        <span>{{ activeUsers }} of {{ seats }} used · {{ seats - activeUsers > 0 ? seats - activeUsers : 0 }} available</span>
      </div>
      <div class="billing-hero-meter-track" role="progressbar" aria-label="Seats used"
        [attr.aria-valuenow]="activeUsers" aria-valuemin="0" [attr.aria-valuemax]="seats">
        <div class="billing-hero-meter-fill" [class.billing-hero-meter-fill--full]="usedPercent >= 90"
          [style.width.%]="usedPercent"></div>
      </div>
      <p class="billing-hero-meter-tip" *ngIf="seatTip as tip" [class.billing-hero-meter-tip--warn]="tip.tone === 'warn'">
        {{ tip.text }}
      </p>
    </div>
  </div>
  <div class="billing-hero-actions" *ngIf="(showPrimary && (actionsReady || actionsPending || showRefresh)) || secondaryLabel">
    <div
      *ngIf="showPrimary && actionsPending"
      class="billing-hero-pending"
      role="status"
      aria-label="Loading billing"
    >
      <mat-spinner diameter="22"></mat-spinner>
    </div>
    <button
      *ngIf="showPrimary && showRefresh"
      mat-stroked-button
      type="button"
      class="billing-hero-refresh"
      (click)="onRefresh()"
    >
      <mat-icon>refresh</mat-icon>
      Refresh
    </button>
    <button
      *ngIf="showPrimary && actionsReady"
      mat-flat-button
      color="primary"
      type="button"
      class="billing-hero-primary"
      (click)="onPrimary()"
    >
      {{ primaryLabel }}
    </button>
    <button
      *ngIf="secondaryLabel && !checkoutOpen"
      mat-button
      type="button"
      class="billing-hero-secondary"
      (click)="onSecondary()"
    >
      {{ secondaryLabel }}
    </button>
  </div>
  <p class="billing-hero-hint" *ngIf="state === 'active' && yearlySaveHint">{{ yearlySaveHint }}</p>
</section>
